module.exports = __webpack_public_path__ + "f50c71c47b83152bdd8228c7b31cc1c8.jpg";